import React, { useState, useEffect, FormEvent } from 'react';
import DeviceSelectionScreen from './DeviceSelectionScreen/DeviceSelectionScreen';
import IntroContainer from '../IntroContainer/IntroContainer';
import MediaErrorSnackbar from './MediaErrorSnackbar/MediaErrorSnackbar';
import RoomNameScreen from './RoomNameScreen/RoomNameScreen';
import { useAppState } from '../../state';
import { useParams, useLocation } from 'react-router-dom';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import { makeStyles, Typography, Grid, Button, Theme, Hidden, Switch, Tooltip } from '@material-ui/core';

export enum Steps {
  roomNameStep,
  deviceSelectionStep,
}

export default function InvalidMeeting() {
  return (
    <IntroContainer>
      <Grid container justifyContent="center" alignItems="center" direction="column" style={{ height: '100%' }}>
        <div>
          {/* <LocalVideoPreview identity={name} />
<ToggleAudioButton className={classes.mobileButton} disabled={disableButtons} />
<ToggleVideoButton className={classes.mobileButton} disabled={disableButtons} /> */}
          <Typography variant="body2" style={{ fontWeight: 'bold', fontSize: '16px' }}>
            Meeting Ended
          </Typography>
        </div>
      </Grid>
    </IntroContainer>
  );
}
